import { AdminUser } from '../types';

const fullAccess = { create: true, read: true, update: true, delete: true };
const noAccess = { create: false, read: false, update: false, delete: false };
const readOnly = { create: false, read: true, update: false, delete: false };
const readEdit = { create: false, read: true, update: true, delete: false };

export const mockAdminUsers: AdminUser[] = [
  {
    id: 'admin-1',
    firstName: 'John',
    lastName: 'Administrator',
    email: 'admin@school.edu',
    phone: '555-0101',
    password: 'Admin123!',
    isActive: true,
    isSuperAdmin: true,
    permissions: {
      canViewMetrics: true,
      students: fullAccess,
      parents: fullAccess,
      community: fullAccess,
      fees: fullAccess,
      feeAssessment: fullAccess,
      orders: fullAccess,
      categories: fullAccess,
      courses: fullAccess,
      schoolYears: fullAccess,
      questionnaires: fullAccess,
      disclaimers: fullAccess,
      notifications: fullAccess,
      buildings: fullAccess,
      schools: fullAccess,
      canBulkImport: true,
      admins: fullAccess,
      workers: fullAccess,
    },
    createdAt: new Date('2024-01-15'),
    lastLogin: new Date('2024-12-10'),
  },
  {
    id: 'admin-2',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@school.edu',
    phone: '555-0102',
    password: 'Sarah123!',
    isActive: true,
    isSuperAdmin: false,
    permissions: {
      canViewMetrics: true,
      students: readEdit,
      parents: readEdit,
      community: noAccess,
      fees: noAccess,
      feeAssessment: noAccess,
      orders: readOnly,
      categories: noAccess,
      courses: fullAccess,
      schoolYears: readOnly,
      questionnaires: fullAccess,
      disclaimers: noAccess,
      notifications: { create: true, read: true, update: true, delete: false },
      buildings: noAccess,
      schools: noAccess,
      canBulkImport: false,
      admins: noAccess,
      workers: noAccess,
    },
    createdAt: new Date('2024-03-20'),
    lastLogin: new Date('2024-12-09'),
  },
  {
    id: 'admin-3',
    firstName: 'Michael',
    lastName: 'Chen',
    email: 'michael.chen@school.edu',
    phone: '555-0103',
    password: 'Michael123!',
    isActive: true,
    isSuperAdmin: false,
    permissions: {
      canViewMetrics: true,
      students: readOnly,
      parents: readOnly,
      community: noAccess,
      fees: fullAccess,
      feeAssessment: fullAccess,
      orders: fullAccess,
      categories: fullAccess,
      courses: noAccess,
      schoolYears: readOnly,
      questionnaires: noAccess,
      disclaimers: fullAccess,
      notifications: noAccess,
      buildings: fullAccess,
      schools: fullAccess,
      canBulkImport: false,
      admins: noAccess,
      workers: fullAccess,
    },
    createdAt: new Date('2024-05-10'),
    lastLogin: new Date('2024-12-08'),
  },
  {
    id: 'admin-4',
    firstName: 'Emily',
    lastName: 'Rodriguez',
    email: 'emily.rodriguez@school.edu',
    phone: '555-0104',
    password: 'Emily123!',
    isActive: false,
    isSuperAdmin: false,
    permissions: {
      canViewMetrics: false,
      students: noAccess,
      parents: noAccess,
      community: noAccess,
      fees: noAccess,
      feeAssessment: noAccess,
      orders: noAccess,
      categories: noAccess,
      courses: noAccess,
      schoolYears: noAccess,
      questionnaires: noAccess,
      disclaimers: noAccess,
      notifications: noAccess,
      buildings: noAccess,
      schools: noAccess,
      canBulkImport: false,
      admins: noAccess,
      workers: noAccess,
    },
    createdAt: new Date('2024-02-28'),
    lastLogin: new Date('2024-08-15'),
  },
];
